import angular from 'angular';
import { sqScorecardStore } from '@/investigate/scorecard/scorecard.store';

angular.module('Sq.Investigate').store('sqScorecardStore', sqScorecardStore);
